import React from 'react';
import classNames from "classnames";
import {IonButton, IonButtons, IonContent, IonHeader, IonModal, IonTitle, IonToolbar} from "@ionic/react";

const ModalBody: React.FC = ({children}) => {
  return (
    <div className="flex flex-col h-full overflow-hidden w-full BODY">
      {children}
    </div>
  );
}

export default ModalBody;


interface ModalBodyPartProps {
  className?: string;
}

export const ModalBodyPart: React.FC<ModalBodyPartProps> = ({children, className}) => {
  return (
    <div
      className={classNames("flex-grow flex flex-col overflow-hidden w-full relative PART", className)}
    >
      {children}
    </div>
  );
}


interface ModalContentProps {
  className?: string;
}


export const ModalContent: React.FC<ModalContentProps> = ({children, className}) => {
  return (
    <div
      className={classNames("flex-grow flex flex-col overflow-y-auto px-4 pt-4 CONTENT", className)}
      style={{marginBottom: '84px'}}
    >
      {children}
    </div>
  );
}

interface ModalFooterProps {
  message?: string;
}

export const ModalFooter: React.FC<ModalFooterProps> = ({children, message}) => {
  return (
    <div
      className="bg-gray-300 py-2 px-6 flex flex-col gap-2 absolute bottom-0 left-0 right-0 justify-center overflow-hidden w-full"
      style={{minHeight: '84px'}}
    >
      {message &&
        <div className="text-center text-xs">
          {message}
        </div>
      }
      {children &&
        <div className="flex items-center justify-center">
          {children}
        </div>
      }
    </div>
  );
}

interface ModalProps extends React.PropsWithChildren<any> {
  isOpen: boolean;
  onDidDismiss: () => void;
  title: string;
  hideCancel?: boolean;
  cancelLabel?: string;
  noPadding?: boolean;
}

export const Modal: React.FC<ModalProps> = (props) => {
  const {isOpen, onDidDismiss, title, hideCancel, cancelLabel,
    noPadding, children} = props;

  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={onDidDismiss}
    >
      <IonHeader>
        <IonToolbar>
          <IonTitle>
            {title}
          </IonTitle>
          {!hideCancel &&
            <IonButtons slot="end">
              <IonButton
                onClick={onDidDismiss}
              >
                {cancelLabel || 'Cancelar'}
              </IonButton>
            </IonButtons>
          }
        </IonToolbar>
      </IonHeader>

      <IonContent
        className={classNames({'ion-padding': !noPadding})}
      >
        {children}
      </IonContent>
    </IonModal>
  )
}